<div #wrapper class="change-diary-wrapper">
    <app-modal-header [text]="'change_product_modal_title' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body">
        <app-alerts-components
                *ngIf="showNotFound"
                [disableClose]="true"
                [icon]="'fa fa-info-circle'"
                [id]="'change-diary-not-found' + rand() "
                [title]="'change_not_found_products' | localise"
                [message]="'change_not_found_products_text' | localise"></app-alerts-components>

        <table class="table" style="table-layout: fixed;">
            <tbody>
            <ng-container *ngFor="let product of products">
                <tr>
                    <td class="title-td" style="width: 65%; padding: 10px 0px; white-space: initial !important;">
                        <ng-container *ngIf="product.images.length > 0">
                            <div
                                    [ngStyle]="{'background': 'url(\''+constants.imagesUrl() + '/images/100x100/' + product.images[0].type + '/' + product.images[0].name + '/'+'\') center center no-repeat', 'background-size': 'contain'}"
                                    style="
                                    width: 56px;
                                    height: 56px;
                                    float: left;
                                "></div>
                        </ng-container>


                        <div style="float: left; line-height: 1.3rem; padding: 6px 12px;">
                            {{ product.title }}
                            <br/>
                            <ng-container *ngIf="product.type_calculation === 'WEIGHT'">
                                <strong>
                                    {{ round(product.calculations.weight) }}
                                    {{ 'abbreviation_gram' | localise }}
                                </strong>
                            </ng-container>

                            <ng-container *ngIf="product.type_calculation === 'QTY'">
                                <strong>
                                    {{ product.calculations.qty }}
                                    {{ 'br' | localise }}
                                </strong>
                            </ng-container>

                        </div>

                        <div style="clear: both;"></div>
                    </td>

                    <td style="text-align: right;">
                        <button
                                *ngIf="this.diaryRecipe"
                                type="button"
                                (click)="changeProduct(product)"
                                style="padding: 13px 18px; font-size: 1rem;"
                                class="btn btn-success btn-icon-text how-to-cook-btn">
                            <i class="fa-exchange fa btn-icon-prepend"></i>
                            {{ 'change_product_modal_choose' | localise }}
                        </button>
                    </td>

                </tr>
            </ng-container>
            </tbody>
        </table>
    </div>
</div>
